const apiEndPoints = {
  SIGNUP: "/ov2/sign_up_user",
  SIGNIN: "/user/login",
  SIGNUP_DOCTOR: "doctor/validation_doctor_dm",
  LAST_LOGIN: "/user/last_login",
  LOGIN_REQUEST: "/oncoViz/login_request",
  patientCount: "/ov2/get_total_patient_count",
  monthlyPatientData : "/ov2/patient_count_by_months",
  primaryCancersite: "/ov2/get_distinct_cancerSite_count",
  CancersiteDistribution: "/ov2/get_cancerSite_data",
  MajorTop10Cancersite: "/ov2/get_top_10_cancerSite_data",
  TMB: "/ov2/get_tmb_status_count",
  MSI: "/ov2/get_msi_status_count",
  PDL: "/ov2/get_pdl_status_count",
  GendervsAge: "/ov2/get_age_group_and_gender_data",
  ImmonotherapyDrugs: "/ov2/get_immuno_drug_response",
  TreatmentResponse: "/ov2/get_treatment_response",
  //  SomaticGermline: '/ov2/get_test_details_list',
  SomaticGermline: "ov2/get_patient_sample_test_details",
  variantTypeResponse: "/ov2/get_variant_details",
  TreatmentDistribution: "/ov2/get_treatment_distribution",
  BiologicalTherapy: "/ov2/get_biological_therapy_response",
  SystematicDrugTherapy: "/ov2/get_drug_therapy_response",
  BioMarkers: "/ov2/get_biomarkers_data",
  Top4CancerSite: "/ov2/get_top_4_cancersite_patient_count",
  Top4Morphology: "/ov2/get_top_4_morphology_patient_count",
  MultiModalTreatments: "/ov2/get_more_than_one_treatment_patient_count",
  Proteomics: "/ov2/get_proteomics_count",
  CancerSitedropdown: "/ov2/get_cancer_site_list",
  GenesDropdown: "/ov2/get_gene_list",
  DashboardTotalVal: "/dashboardAnalysis/get_total_patient_count",
  hospital_city_details: "/ov2/get_hospital_city_details",
  hospital_name_details_by_city:
    "/ov2/get_hospital_name_details_by_city/{hospitalCity}",
  protein_change_details: "/ov2/get_protein_change_details",
  immuno_dropdown: "ov2/get_immuno_drugs_list",
  hospital_city_dropdown: "/ov2/get_hospital_city_list",
  hospital_name_dropdown: "/ov2/get_hospital_name_list",
  targeted_therapy_drug: "/ov2/get_targeted_drug_response",
  cancer_stage_details: "/ov2/get_cancer_stage_details",
  no_cancer_site_patients: "/ov2/get_no_cancer_site_patients",
  morphology_details: "/ov2/get_morphology_data",
  getTestTypeGraph: "/ov2/test_type_details",
  doctors_dropdown_data: "/ov2/get_doctors_dropdown_data",
  targeted_therapy_filter: "/ov2/get_targeted_drop_down_response",
  country_dropdown: "/ov2/country_dropdown_data",
  state_dropdown: "/ov2/state_dropdown_data",
  excel_download: "/ov2/download_excel",
  clinical_significance: "/ov2/gene_clinical_significance_dropdown_data",
  genderList: "/ov2/filter_by_gender_list",
  checkHasLungAccess: "/ov2/check_has_lung_access",
};

export const HomePageEndpoints = {
  TreatmentDistribution: "/ov2/home/get_treatment_distribution",
  BiologicalTherapy: "/ov2/home/get_biological_therapy_response",
  SystematicDrugTherapy: "/ov2/home/get_drug_therapy_response",
  patientCount: "/ov2/home/get_total_patient_count",
  primaryCancersite: "/ov2/home/get_distinct_cancerSite_count",
  BioMarkers: "/ov2/home/get_biomarkers_data",
};
export default apiEndPoints;
